import { cn } from "../../utils/common/cn";
import { LucideIcon } from "lucide-react";
import React from "react";

interface MetricCardProps {
  label: string;
  value: string | number;
  subValue?: string;
  icon?: LucideIcon;
  trend?: "up" | "down" | "neutral";
  trendValue?: string;
  variant?: "default" | "highlight" | "warning" | "success";
  className?: string;
}

export function MetricCard({
  label,
  value,
  subValue,
  icon: Icon,
  trend,
  trendValue,
  variant = "default",
  className,
}: MetricCardProps) {
  return (
    <div
      className={cn(
        "metric-card",
        variant === "highlight" && "border-primary/50 bg-primary/5",
        variant === "warning" && "border-warning/50 bg-warning/5",
        variant === "success" && "border-success/50 bg-success/5",
        className
      )}
    >
      <div className="flex items-start justify-between">
        <div className="space-y-1">
          <p className="metric-label">{label}</p>
          <p className={cn(
            "metric-value",
            variant === "warning" && "text-warning",
            variant === "success" && "text-success"
          )}>
            {value}
          </p>
          {subValue && (
            <p className="text-sm text-muted-foreground">{subValue}</p>
          )}
        </div>
        {Icon && (
          <div className={cn(
            "flex h-10 w-10 items-center justify-center rounded-lg",
            variant === "highlight" && "bg-primary/10",
            variant === "warning" && "bg-warning/10",
            variant === "success" && "bg-success/10",
            variant === "default" && "bg-muted"
          )}>
            <Icon className={cn(
              "h-5 w-5",
              variant === "highlight" && "text-primary",
              variant === "warning" && "text-warning",
              variant === "success" && "text-success",
              variant === "default" && "text-muted-foreground"
            )} />
          </div>
        )}
      </div>
      {trend && trendValue && (
        <div className="mt-3 flex items-center gap-1 text-sm">
          <span
            className={cn(
              trend === "up" && "text-success",
              trend === "down" && "text-destructive",
              trend === "neutral" && "text-muted-foreground"
            )}
          >
            {trend === "up" ? "↑" : trend === "down" ? "↓" : "→"} {trendValue}
          </span>
        </div>
      )}
    </div>
  );
}
